import { render, staticRenderFns } from "./goodsDialog.vue?vue&type=template&id=91594144&scoped=true&"
import script from "./goodsDialog.vue?vue&type=script&lang=js&"
export * from "./goodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./goodsDialog.vue?vue&type=style&index=0&id=91594144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91594144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91594144')) {
      api.createRecord('91594144', component.options)
    } else {
      api.reload('91594144', component.options)
    }
    module.hot.accept("./goodsDialog.vue?vue&type=template&id=91594144&scoped=true&", function () {
      api.rerender('91594144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goodsDialog.vue"
export default component.exports